<template>
    <div class="animated fadeIn">

      <b-card class="card-accent-info">

      <div slot="header">
            Contas a Pagar e Receber
            <div class="card-header-actions">
              <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                  <i class="icon-arrow-up"></i>
              </b-link>
              
              <!--
              <b-link href="#" class="card-header-action btn-help">
                <i class="icon-question"></i>
              </b-link>
              
              <b-link href="#" class="card-header-action btn-helpvie">
                <i class="icon-film"></i>
              </b-link>
              -->
            </div>
      </div>

    
      <b-collapse id="collapse1" visible>
        <b-card-body>

          <b-row>
            <b-col cols="auto">
              <b-form-group >
                  <label for="perPage">Empresa</label>
                  <b-form-select v-model="filters.companyId" id="filterCompany"
                    :plain="true"
                    :options="this.companyDDL"
                    @change="refreshByCompany(filters.companyId);"
                    >
                  </b-form-select>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="filterCostCenter">Centro de Custo</label>
                  <b-form-select v-model="filters.costCenterId" id="filterCostCenter" value-field="label" text-field="text"
                    :plain="true"
                    :options="this.costCenterDDL"                   
                    >
                  </b-form-select>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="startDate">Período</label>
                  <b-form-input v-model="filters.startDate" type="date" id="startDate"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="startDate">&nbsp;&nbsp;&nbsp;</label>
                  <b-form-input v-model="filters.endDate" type="date" id="endDate"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Filtrar</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>


        </b-card-body>
      </b-collapse>

      </b-card>
      


      <b-row>
        <b-col md="12" lg="6">
          <b-card no-body class="bg-primary">
            <b-card-body class="pb-0">
                <b-dropdown class="float-right" variant="transparent p-0" right>
                <template slot="button-content">
                  <i class="icon-settings"></i>
                </template>
                <b-dropdown-item :to="{ path: '/finance/accountsreceivable' }">Contas a Receber</b-dropdown-item>
              </b-dropdown>
              <h4 class="mb-0">{{ dashboardData.accountsReceivableCount }}</h4>
              <p>Contas a Receber</p>
              <h4 class="mb-0">R$ {{ $utils.numberFormat(dashboardData.accountsReceivableTotal) }}</h4>

              <div style="min-height: 70px;"></div>
            </b-card-body>
            
          </b-card>

          <b-row>
            <b-col md="12" lg="12" xl="6">
              <b-card no-body class="card-accent-primary">
                <b-card-body class="pb-0">
                    
                  <h4 class="mb-0">{{ dashboardData.accountsReceivablePayedCount }}</h4>
                  <p>A Receber - Recebidos</p>
                </b-card-body>
                <div style="min-height:70px">
                  <h4 class="text-center">R$ {{ $utils.numberFormat(dashboardData.accountsReceivablePayedTotal)  }}</h4>
                </div>
              </b-card>
            </b-col>

            <b-col md="12" lg="12" xl="6">
              <b-card no-body class="card-accent-primary">
                <b-card-body class="pb-0">
                
                  <h4 class="mb-0">{{ dashboardData.accountsReceivableCount - dashboardData.accountsReceivablePayedCount  }}</h4>
                  <p>A Receber - Abertos</p>
                </b-card-body>
                <div style="min-height:70px">
                  <h4 class="text-center">R$ {{ $utils.numberFormat(dashboardData.accountsReceivableOpenTotal)  }}</h4>
                </div>

              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-card no-body class="card-accent-primary">
                <dashboard-grid-component
                  :items = "dashboardData.accountsReceivable"
                ></dashboard-grid-component>
              </b-card>
            </b-col>
          </b-row>


        </b-col>
        
        
        <b-col md="12" lg="6">
          <b-card no-body class="bg-danger">
            <b-card-body class="pb-0">
              <b-dropdown class="float-right" variant="transparent p-0" right>
                <template slot="button-content">
                  <i class="icon-settings"></i>
                </template>
                <b-dropdown-item :to="{ path: '/finance/accountspayable' }">Contas a Pagar</b-dropdown-item>
              </b-dropdown>
              <h4 class="mb-0">{{ dashboardData.accountsPayableCount }}</h4>
              <p>Contas a Pagar</p>
              <h4 class="mb-0">R$ {{ $utils.numberFormat(dashboardData.accountsPayableTotal) }}</h4>


            </b-card-body>
            <div style="min-height: 70px;"></div>
          </b-card>

          <b-row>
            <b-col md="12" lg="12" xl="6">
              <b-card no-body class="card-accent-danger">
                <b-card-body class="pb-0">
                  <h4 class="mb-0">{{ dashboardData.accountsPayablePayedCount }}</h4>
                  <p>A Pagar - Pagos</p>
                </b-card-body>
                
                <div style="min-height:70px">
                  <h4 class="text-center">R$ {{ $utils.numberFormat(dashboardData.accountsPayablePayedTotal)  }}</h4>
                </div>
                
              </b-card>
            </b-col>

            <b-col md="12" lg="12" xl="6">
              <b-card no-body class="card-accent-danger">
                <b-card-body class="pb-0">
                  <h4 class="mb-0">{{ dashboardData.accountsPayableCount - dashboardData.accountsPayablePayedCount  }}</h4>
                  <p>A Pagar - Abertos</p>
                </b-card-body>
                <div style="min-height:70px">
                  <h4 class="text-center">R$ {{ $utils.numberFormat(dashboardData.accountsPayableOpenTotal)  }}</h4>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-card no-body class="card-accent-danger">
                <dashboard-grid-component
                  :items = "this.dashboardData.accountsPayable"
                ></dashboard-grid-component>
              </b-card>
            </b-col>
          </b-row>

        </b-col>
      </b-row>

    </div>
  </template>
  
  <script>
  import DashboardGridComponent from './DashboardGridComponent'

  import axios from "axios";
  
  export default {
    name: 'dashboard',
    components: {
      DashboardGridComponent
    },
    data: function () {
      return {

        dashboardData: {
          accountsPayableCount: 0,
          accountsPayablePayedCount: 0,
          accountsPayableTotal: 0,
          accountsPayablePayedTotal: 0,
          accountsPayableOpenTotal: 0,

          accountsReceivableCount: 0,
          accountsReceivablePayedCount: 0,
          accountsReceivableTotal: 0,
          accountsReceivablePayedTotal: 0,
          accountsReceivableOpenTotal: 0
        },
        filters: {
          companyId: 0,
          costCenterId: 0,
          startDate: null,
          endDate: null
        },

        companyDDL: [],
        costCenterDDL: [],

        name: 'tables',
        
      }
    },
    computed: {
     
    },
    methods: {
      variant (value) {
        let $variant
        if (value <= 25) {
          $variant = 'info'
        } else if (value > 25 && value <= 50) {
          $variant = 'success'
        } else if (value > 50 && value <= 75) {
          $variant = 'warning'
        } else if (value > 75 && value <= 100) {
          $variant = 'danger'
        }
        return $variant
      },
      flag (value) {
        return 'flag-icon flag-icon-' + value
      },
      async getCostCenter(companyId) {
        var s = this
        var currentUser = this.$store.state.currentUser
        await axios.get(
            this.$store.state.ws_url + "/costcenter/ddl?companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.costCenterDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        })
       
      },
     
      refreshByCompany(companyId) {
        this.refreshData();
        this.getCostCenter(companyId);
      },
      async refreshData() {

        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/finance/dashboard?companyId=" + s.filters.companyId + "&startDate=" + s.filters.startDate + "&endDate="  + s.filters.endDate + "&uid=" + currentUser.id + "&sid=" + currentUser.sid            
        ).then(function(resp) {
          s.dashboardData = resp.data.obj
        }).catch(function (error) {
          console.log(error);
        });
      
      }
    },
    mounted: function() {
      var now = new Date();

      // Primeiro dia
      this.filters.startDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth(), 1))
      // Último dia
      this.filters.endDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth() + 1, 0))

      this.companyDDL = this.$store.state.currentUser.companies
      var companyId = this.$store.state.config.companyId
      this.filters.companyId = companyId;
      
      this.refreshByCompany(companyId);
    }
  }
  
  
  </script>
  
  <style>
    /* IE fix */
    #card-chart-01, #card-chart-02 {
      width: 100% !important;
    }
  </style>
  